





















































































































import { computed, defineComponent, reactive, ref } from "@vue/composition-api";
import Layout from "@/components/Atoms/Layout/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import Pagination from "@/components/Atoms/Pagination/index.vue";
import PageHeader from "@/components/Molecules/PageHeader/index.vue";
import ListFilter from "@/components/Molecules/ListFilter/index.vue";
import FilterSection from "@/components/Molecules/FilterSection/index.vue";
import OccSearchMultiSelectbox from "@/components/Atoms/OccSearchMultiSelectbox/index.vue";
import OccSearchSelectbox from "@/components/Atoms/OccSearchSelectbox/index.vue";
import Checkbox from "@/components/Atoms/Forms/Checkbox/index.vue";
import SearchTextField from "@/components/Atoms/Forms/SearchTextField/index.vue";
import LoadingView from "@/components/Molecules/LoadingView/index.vue";
import { Props } from "@/components/Molecules/ListTable/index.vue";
import TableFooter from "@/components/Molecules/TableFooter/index.vue";
import AcceptanceTable from "../Acceptances/Organisms/AcceptanceTable.vue";
import CsvCustomizeModal from "@/components/Organisms/CsvCustomizeModal/index.vue";
import ConfirmModal from "@/components/Organisms/modals/ConfirmModal/index.vue";
import DateRangeSelector from "@/components/Molecules/DateRangeSelector/index.vue";
import {
  getAgentScoutAcceptances,
  getAgentScoutAcceptanceSearchOptions,
  startGenerateAgentScoutAcceptancesCsv,
  getPartnerEntryCsvColumns,
  upsertPartnerEntryCsvColumns
} from "@/api";
import {
  PRIVILEGE_ENTRIES_DOWNLOAD,
  hasPrivilege
} from "@/helpers/privilege-helper";
import { useRequest } from "@/helpers/hooks/useRequest";
import { selectListGenerator } from "../Acceptances/methods";
import { ApiRequest, ApiResponse, Order } from "@/api/types";
import { CsvColumns } from "@/components/Organisms/CsvCustomizeModal/types";
import { useStore } from "@/store";

type AgentScoutAcceptanceFilterData = {
  keyword: string;
  starred: boolean;
  universities: string[];
  graduateYears: string[];
  grades: string[];
  acceptedDate: { from: string; to: string };
};

type AgentScoutAcceptanceFilterName =
  | "starred"
  | "universities"
  | "graduateYears"
  | "grades"
  | "acceptedDate";

type AgentScoutAcceptanceFilterType =
  | "checkbox"
  | "multiSelectbox"
  | "dateRange";

interface AgentScoutAcceptanceFilterCondition {
  label: string;
  checkbox_label?: string;
  name: AgentScoutAcceptanceFilterName;
  type: AgentScoutAcceptanceFilterType;
}

export default defineComponent({
  name: "AgentScoutAcceptances",
  components: {
    Layout,
    OccHeading,
    OccButton,
    Pagination,
    PageHeader,
    ListFilter,
    FilterSection,
    OccSearchMultiSelectbox,
    OccSearchSelectbox,
    Checkbox,
    SearchTextField,
    LoadingView,
    TableFooter,
    AcceptanceTable,
    CsvCustomizeModal,
    ConfirmModal,
    DateRangeSelector
  },
  setup() {
    const store = useStore();
    /** ========================================
     * フィルタ
     * ========================================*/
    const filterState = reactive<AgentScoutAcceptanceFilterData>({
      keyword: "",
      starred: false,
      universities: [],
      graduateYears: [],
      grades: [],
      acceptedDate: { from: "", to: "" }
    });

    const [
      { data: searchOptions, loading: searchOptionsLoading },
      runGetAgentScoutAcceptanceSearchOptions
    ] = useRequest(() => getAgentScoutAcceptanceSearchOptions(), {
      immediate: true
    });

    const [
      { data: agentScoutAcceptances, loading: usersLoading },
      runGetAgentScoutAcceptances
    ] = useRequest(
      () =>
        getAgentScoutAcceptances({
          ...searchParams.value,
          limit: displayCount.value,
          offset: displayCount.value * (currentPage.value - 1)
        }),
      { immediate: false }
    );

    const load = async () => {
      await runGetAgentScoutAcceptanceSearchOptions();
      await runGetAgentScoutAcceptances();
      await restoreFilterStateFromQueryParams();
    };
    load();

    const headers = reactive<Props["headers"]>([
      {
        name: "ユーザー名",
        subHeaders: [{ name: "識別コード" }, { name: "カナ" }],
        sizeInner: "100px",
        minSizeContainer: "200px"
      },
      {
        name: "大学名",
        subHeaders: [{ name: "卒年" }, { name: "学年・学部" }],
        sizeInner: "220px",
        minSizeContainer: "220px"
      },
      {
        name: "選考ステータス",
        sizeInner: "100px",
        minSizeContainer: "140px"
      },
      {
        name: "受諾日時",
        sortParam: "checkin_date",
        order: "desc",
        sizeInner: "130px",
        minSizeContainer: "170px"
      }
    ]);

    const hasCsvDownloadPriviledge = hasPrivilege(PRIVILEGE_ENTRIES_DOWNLOAD);

    // クエリパラメータから検索オプションを復元する
    const restoreFilterStateFromQueryParams = async () => {
      setCurrentFilterCount();
    };

    const listFilterConditions: AgentScoutAcceptanceFilterCondition[] = [
      {
        label: "大学",
        name: "universities",
        type: "multiSelectbox"
      },
      {
        label: "卒年",
        name: "graduateYears",
        type: "multiSelectbox"
      },
      {
        label: "学年",
        name: "grades",
        type: "multiSelectbox"
      },
      {
        label: "受諾日時",
        name: "acceptedDate",
        type: "dateRange"
      }
    ];

    const filterCount = ref(0);

    const selectItemList = computed(() => {
      return {
        universities: selectListGenerator(
          searchOptions.value?.universities || []
        ),
        graduateYears: selectListGenerator(
          searchOptions.value?.graduate_years || []
        ),
        grades: selectListGenerator(searchOptions.value?.grades || [])
      };
    });

    const onChangeCheckbox = (
      key: Extract<AgentScoutAcceptanceFilterName, "starred">,
      newVal: boolean[]
    ) => {
      filterState[key] = !!newVal[0];
    };

    const onChangeMultiSelect = (
      key: Exclude<AgentScoutAcceptanceFilterName, "acceptedDate">,
      newVal: string[]
    ) => {
      filterState[key] = newVal as any;
    };

    const onSearchText = async () => {
      moveFiresPage();
      await runGetAgentScoutAcceptances();
    };

    const onSubmitFilter = async () => {
      moveFiresPage();
      await runGetAgentScoutAcceptances();
      setCurrentFilterCount();
    };

    const onResetFilter = async () => {
      filterState.keyword = "";

      listFilterConditions.forEach(condition => {
        const key: keyof typeof filterState = condition.name;
        switch (key) {
          case "starred":
            filterState[key] = false;
            return;
          case "universities":
          case "graduateYears":
          case "grades":
            filterState[key] = [];
            return;
          case "acceptedDate":
            filterState[key] = { from: "", to: "" };
            return;
        }
      });
      moveFiresPage();
      await runGetAgentScoutAcceptances();
      setCurrentFilterCount();
    };

    const setCurrentFilterCount = () => {
      const currentFilterCount = listFilterConditions.reduce(
        (preFilterCount: number, condition) => {
          const key: keyof typeof filterState = condition.name;
          switch (key) {
            case "starred":
              if (filterState[key]) {
                return preFilterCount + 1;
              } else {
                return preFilterCount;
              }
            case "universities":
            case "graduateYears":
            case "grades":
              if (filterState[key].length) {
                return preFilterCount + 1;
              } else {
                return preFilterCount;
              }
            case "acceptedDate":
              if (filterState[key].from || filterState[key].to) {
                return preFilterCount + 1;
              } else {
                return preFilterCount;
              }
            default:
              return preFilterCount;
          }
        },
        0
      );
      filterCount.value = currentFilterCount;
    };

    /** ========================================
     * ページネーション
     * ========================================*/
    const currentPage = ref(1);

    const displayCount = ref(25);

    const displayCountSelectList = [
      { value: 25, label: "25件" },
      { value: 50, label: "50件" },
      { value: 100, label: "100件" },
      { value: 250, label: "250件" },
      { value: 500, label: "500件" }
    ];

    const totalPageCount = computed(() => {
      if (!agentScoutAcceptances.value || !agentScoutAcceptances.value.total) {
        return 1;
      }
      return Math.ceil(agentScoutAcceptances.value?.total / displayCount.value);
    });

    const moveFiresPage = () => {
      currentPage.value = 1;
    };

    const onChangePage = async (pageNumber: number) => {
      currentPage.value = pageNumber;
      await runGetAgentScoutAcceptances();
    };

    const onChangeDisplayCount = async (count: number) => {
      displayCount.value = count;
      moveFiresPage();
      await runGetAgentScoutAcceptances();
    };

    /** ========================================
     * ソート
     * ========================================*/
    const sortState = reactive<ApiRequest.AgentScoutAcceptancesOrder>({
      order: "desc"
    });

    const onChangeOrder = async (order: Order, headerIndex: number) => {
      const targetHeader = headers[headerIndex];
      const sort = targetHeader.sortParam;

      if (!sort) {
        return;
      }

      sortState.order = order;
      targetHeader.order = order;
      moveFiresPage();

      await runGetAgentScoutAcceptances();
    };

    /** ========================================
     * アラート
     * ========================================*/
    const isLoading = computed<boolean>(() => {
      return !!usersLoading.value || !!searchOptionsLoading.value;
    });

    /** ========================================
     * CSV出力カラムの管理
     * ========================================*/
    const availableCsvColumns = [
      { name: "created_at", label: "スカウト受諾日時" },
      { name: "unique_id", label: "識別コード" },
      { name: "name", label: "名前" },
      { name: "name_kana", label: "名前（カナ）" },
      { name: "university_name", label: "大学" },
      { name: "department_name", label: "学部" },
      { name: "email", label: "大学メールアドレス" },
      { name: "internship_results", label: "インターン実績" },
      { name: "high_school", label: "出身高校名" },
      { name: "activities", label: "学生時代の活動実績" },
      { name: "tel", label: "電話番号" },
      { name: "unofficial_offer_results", label: "内定実績" },
      { name: "full_address", label: "住所" },
      { name: "date_of_birth", label: "生年月日" },
      { name: "grade", label: "学年" },
      { name: "graduate_year", label: "卒業年度" },
      { name: "concentration_name", label: "学科" },
      { name: "seminar_circle", label: "ゼミ・研究室" },
      { name: "course", label: "文理" },
      { name: "languages", label: "言語レベル" },
      { name: "self_promotion", label: "自己PR" },
      { name: "student_endeavor", label: "学生時代に頑張ったこと" },
      { name: "business_categories", label: "志望業界" },
      { name: "preferred_job_type_names", label: "志望職種" },
      { name: "preferred_work_prefecture_names", label: "志望勤務地" },
      { name: "company_choice_factor_names", label: "企業選びの軸" }
    ];

    const partnerEntryCsvColumns = ref<ApiResponse.PartnerEntryCsvColumn[]>();
    const excludedColumns = ref<CsvColumns[]>([]);
    const includedColumns = ref<CsvColumns[]>([]);

    const runGetPartnerEntryCsvColumns = async () => {
      const response = await getPartnerEntryCsvColumns();
      partnerEntryCsvColumns.value = response.data.csv_columns;
      updateDisplayCsvColumns();
    };

    const updateDisplayCsvColumns = () => {
      if (!partnerEntryCsvColumns.value) {
        return;
      }

      includedColumns.value = [];
      excludedColumns.value = [];

      partnerEntryCsvColumns.value.forEach(item => {
        const csvColumnObj = getCsvColumnObj(item.column);
        if (csvColumnObj) {
          includedColumns.value.push(csvColumnObj);
        }
      });

      excludedColumns.value = availableCsvColumns.filter(item => {
        return !includedColumns.value.find(includedCol => {
          return includedCol.name === item.name;
        });
      });
    };

    const getCsvColumnObj = (column: string) => {
      return availableCsvColumns.find(item => {
        return item.name === column;
      });
    };

    const csvColumnsSaveParams = computed(() => {
      const csvColumns = includedColumns.value.map((item, idx) => {
        return { column: item.name, position: idx };
      });
      if (
        partnerEntryCsvColumns.value?.find(
          item => item.column === "partner_entry_offer"
        )
      ) {
        const insertIndex = csvColumns.length;
        csvColumns.push({
          column: "partner_entry_offer",
          position: insertIndex
        });
      }
      if (
        partnerEntryCsvColumns.value?.find(
          item => item.column === "entry_route"
        )
      ) {
        const insertIndex = csvColumns.length;
        csvColumns.push({
          column: "entry_route",
          position: insertIndex
        });
      }
      if (
        partnerEntryCsvColumns.value?.find(
          item => item.column === "event_entry_state"
        )
      ) {
        const insertIndex = csvColumns.length;
        csvColumns.push({
          column: "event_entry_state",
          position: insertIndex
        });
      }

      return {
        csv_columns: csvColumns
      };
    });

    const runUpsertPartnerEntryCsvColumns = async () => {
      const response = await upsertPartnerEntryCsvColumns(
        csvColumnsSaveParams.value
      );
      if (response.status !== 204) {
        showCsvDownloadError();
      }
    };

    /** =======================================
     * CSVダウンロード
     * =======================================*/
    const onClickCsvDownload = () => {
      showCsvCustomizeModal();
    };
    const csvCustomizeModalShow = ref<boolean>(false);

    const closeCsvCustomizeModal = () => {
      csvCustomizeModalShow.value = false;
    };

    const showCsvCustomizeModal = async () => {
      await runGetPartnerEntryCsvColumns();
      csvCustomizeModalShow.value = true;
    };

    const csvDownloadConfirmModalShow = ref(false);

    const closeCsvDownloadConfirmModal = () => {
      csvDownloadConfirmModalShow.value = false;
    };

    const updateCsvIncludedColumns = (
      newArray: {
        name: string;
        label: string;
      }[]
    ) => {
      includedColumns.value = newArray;
    };
    const updateCsvExcludedColumns = (
      newArray: {
        name: string;
        label: string;
      }[]
    ) => {
      excludedColumns.value = newArray;
    };

    const searchParams = computed<ApiRequest.AgentScoutAcceptancesBase>(() => {
      const params: ApiRequest.AgentScoutAcceptancesBase = {
        keyword: filterState.keyword,
        starred: filterState.starred || undefined,
        universities: filterState.universities,
        graduate_years: filterState.graduateYears,
        grades: filterState.grades,
        order: sortState.order
      };

      // 以下はoptionalパラメータであるため、設定がある場合のみ追加する
      if (filterState.acceptedDate.from !== "") {
        params.accepted_date_from = filterState.acceptedDate.from;
      }
      if (filterState.acceptedDate.to !== "") {
        params.accepted_date_to = filterState.acceptedDate.to;
      }

      return params;
    });

    const csvDownloadColumns = ref<string[]>();
    const csvDownloadParams = computed(() => {
      return {
        ...searchParams.value,
        output_columns: csvDownloadColumns.value || []
      };
    });

    const applyCsvDownload = async (items: string[]) => {
      await Promise.all([
        runUpsertPartnerEntryCsvColumns(),
        runCsvDownload(items)
      ]);
    };

    const runCsvDownload = async (items: string[]) => {
      csvDownloadColumns.value = items;
      const response = await startGenerateAgentScoutAcceptancesCsv(
        csvDownloadParams.value
      );
      if (response.status === 200) {
        csvDownloadConfirmModalShow.value = true;
      } else {
        showCsvDownloadError();
      }
    };

    const showCsvDownloadError = () => {
      store.commit("common/updateAlertView", {
        isVisible: true,
        title: "ダウンロードに失敗しました。リロードして再度お試しください。"
      });
    };

    const currentDateStr = computed<string>(() => {
      return new Date().toISOString().slice(0, 10);
    });

    const handleChangedAcceptedDateFrom = (value: string) => {
      filterState.acceptedDate.from = value;
    };

    const handleChangedAcceptedDateTo = (value: string) => {
      filterState.acceptedDate.to = value;
    };

    return {
      searchOptions,
      agentScoutAcceptances,
      usersLoading,
      searchOptionsLoading,
      headers,
      hasCsvDownloadPriviledge,

      filterState,
      listFilterConditions,
      filterCount,
      selectItemList,
      onChangeCheckbox,
      onChangeMultiSelect,
      onSearchText,
      onSubmitFilter,
      onResetFilter,

      currentPage,
      displayCount,
      displayCountSelectList,
      totalPageCount,
      onChangePage,
      onChangeDisplayCount,

      onChangeOrder,

      isLoading,

      onClickCsvDownload,
      csvCustomizeModalShow,
      closeCsvCustomizeModal,
      showCsvCustomizeModal,
      csvDownloadConfirmModalShow,
      closeCsvDownloadConfirmModal,
      excludedColumns,
      includedColumns,
      applyCsvDownload,
      updateCsvIncludedColumns,
      updateCsvExcludedColumns,

      currentDateStr,
      handleChangedAcceptedDateFrom,
      handleChangedAcceptedDateTo
    };
  }
});
